import { useaxios } from "../../../utils/useaxios";
export default (sell_invoice_note, user_id, items, sell_invoice_type, customer_id) => recaller => setrecaller => initDispatch => clear => printit => setsell_loading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('sell_invoice/create.php', { sell_invoice_note, user_id, sell_invoice_date: today, items, sell_invoice_type, customer_id }).then((res) => {
        if (res == "auth_failed") {
            setsell_loading(false);
            alert('no internet connection');
            return false;
        }
        if (res.status == "ok") {
            // printit(res.invoiceno);
            // setTimeout(() => {
            setrecaller(recaller + 1);
            // }, 1000);
        } else {
            // clear();
        }
        // setloading(false);
    });
}